import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Meta } from '@angular/platform-browser';
import { AuthStorageService, UserIdService } from '@spartacus/core';
import { Observable, throwError } from 'rxjs';
import { catchError, take } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

export interface PaginationModel {
  currentPage?: number;
  hasNext?: boolean;
  hasPrevious?: boolean;
  needsTotal?: boolean;
  numberOfPages?: number;
  pageSize?: number;
  totalNumberOfResults?: number;
  totalPages?: number;
}
export interface Sorts {
  asc?: boolean;
  code?: string;
  name?: string;
  selected?: boolean;
}

export interface SearchPageData {
  pagination: PaginationModel;
  results?: any;
  sorts?: Sorts[];
  searchTerm?: string;
}

export interface DealerSelectorListPayload {
  asmUserId: string;
  searchPageData: SearchPageData;
}

@Injectable({
  providedIn: 'root',
})
export class DealerService {
  occUrl = this.meta.getTag('name=occ-backend-base-url');
  url = `${this.occUrl.content}${environment.prefix}`;
  userCurrent$: Observable<string> = this.userIdService.getUserId();
  headers = new HttpHeaders()
    .set('Authorization', `${this.token.token_type} ${this.token.access_token}`)
    .set('Content-Type', 'application/json');

  constructor(
    private http: HttpClient,
    private userIdService: UserIdService,
    protected authStorageService: AuthStorageService,
    private meta: Meta
  ) {}

  get token(): any {
    let token: any;
    this.authStorageService
      .getToken()
      .pipe(take(1))
      .subscribe((tokenIdData) => (token = tokenIdData));
    return token;
  }

  userCurrent(): string {
    let userId: string;
    this.userIdService
      .getUserId()
      .pipe(take(1))
      .subscribe((tokenIdData) => (userId = tokenIdData));
    return userId;
  }

  getDealerSelectorList(payload: DealerSelectorListPayload, isShipTo: boolean) {
    let endpoint: string = isShipTo ? '/dealer-selector/shipToAddresses' : '/dealer-selector';

    if (isShipTo) {
      delete payload.searchPageData.sorts;
    }

    return this.http
      .post(
        `${this.url}basesites/assisted-service/${encodeURI(payload.asmUserId)}${endpoint}`,
        {
          ...payload.searchPageData,
        },
        {
          headers: this.headers,
        }
      )
      .pipe(catchError((error: any) => throwError(error)));
  }
}
